module.exports = __webpack_public_path__ + "static/media/desktop-solid.adf9cc42.svg";